import React from "react";
import { useSelector } from "react-redux";
import {
    selectRegistrationAccount,
    updateRegistrationAccountFormView,
    updateRegistrationAccountSubmitted,
    updateRegistrationAccountSubmittedMessage,
    updateRegistrationAccountIsLoggedIn,
    updateRegistrationAccountHasActivatedAccount,
} from "../../../redux/slices/registrationAccountSlice";

import AccountFormContent from "./AccountFormContent";

const ConnectedAccountFormContent = () => {
    const selectedRegistrationAccount = useSelector(selectRegistrationAccount);
    const {
        contact: { email },
        form: { initialGlobalAccountAction, location, uniqueIdentifier },
        urls: { myFundraisingDashboard, participantAction },
    } = selectedRegistrationAccount;

    // Refined version of the registrationAccount object from state with
    // only the keys that affect this component or its dependencies
    const registrationAccount = {
        contact: {
            email,
        },
        form: {
            initialGlobalAccountAction,
            location,
            uniqueIdentifier,
        },
        urls: {
            myFundraisingDashboard,
            participantAction,
        },
    };

    const accountFormContentProps = {
        registrationAccount,
        updateRegistrationAccountFormView,
        updateRegistrationAccountSubmitted,
        updateRegistrationAccountSubmittedMessage,
        updateRegistrationAccountIsLoggedIn,
        updateRegistrationAccountHasActivatedAccount,
    };
    return <AccountFormContent {...accountFormContentProps} />;
};

export default ConnectedAccountFormContent;
